import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightTaillightProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function RearRightTaillight(props: RearRightTaillightProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Rear Right Taillight"
      width={100}
      height={75}
      viewBox="0 0 100 75"
      position={{top: 30, right: 36}}
    >
      <path
        d="M1 1C1.0804 1 1.16141 1.00012 1.24302 1.00038C12.089 6.0217 22.3724 10.8357 28 12C55.0129 17.5888 63.633 28.9731 70 41C72.101 44.9686 75.2595 50.0591 79 57C82.1125 58.4319 84.8615 60.2891 87 62C90.0937 64.475 94.0347 67.7927 98 72C95 47 87 26 78 19C62.2876 6.77926 18.4176 1.05426 1.24302 1.00038C1.24274 1.00025 1.24246 1.00013 1.24219 1H1Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M49 19C53 18 61 15 64 12"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M98 72C95 47 87 26 78 19C62.213 6.72119 18 1 1 1H1.24219C12.0885 6.02145 22.3722 10.8356 28 12C55.0129 17.5888 63.633 28.9731 70 41C72.101 44.9686 75.2595 50.0591 79 57C82.1125 58.4319 84.8615 60.2891 87 62C90.0937 64.475 94.0347 67.7927 98 72Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
